// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3kToE","icon":"style_icon__2-2d3"};